import { useDispatch, useSelector } from "react-redux";

// Component imports
import FileUploadComponent from "components/CreateNotification/components/fileUploadComponent";
import InputComp from "themes/elements/Input";
import RadioComp from "themes/elements/Radio";
import SelectComp from "themes/elements/Select";

// Redux actions
import {
  setDestinationScreen,
  setDestinationType,
  setDisplayText,
  setExternalLink,
} from "pages/Notification/notificationDestinationSlice";

// Styles
import style from "../../create_noti.module.scss";

// Radio options for destination type
export const notificationTypeData = [
  {
    label: "None",
    value: "None",
  },
  {
    label: "In-app",
    value: "In-app",
  },
  {
    label: "External",
    value: "External",
  },
];

const MessageContent = (props) => {
  const dispatch = useDispatch();

  const {
    destinationType,
    destinationScreen,
    notificationTypeSettings,
    externalLink,
    displayText,
  } = useSelector((state) => state.notificationDestination);

  const {
    formData,
    data,
    handleInputChange,
    notificationType,
    setFormData,
    isReadOnly = false,
  } = props;

  const handleDestinationChange = (value) => {
    dispatch(setDestinationScreen(null));
    dispatch(setExternalLink(null));
    dispatch(setDisplayText(null));

    dispatch(setDestinationType(value));
    setFormData((prevData) => ({
      ...prevData,
      destinationScreen: "",
      externalLink: "",
      displayText: "",
    }));
  };

  return (
    <div className={`flex flex-column gap-4 w-full ${style["right-section"]}`}>
      <>
        <InputComp
          label="Title"
          name="title"
          placeholder="Provide title of the announcement"
          value={formData?.title}
          onChange={handleInputChange}
          maxLength={notificationType === "Alert" ? 60 : 100}
          showCount
          disabled={isReadOnly}
        />

        <InputComp
          label="Message content"
          name="content"
          placeholder="Type the article content..."
          value={formData.messageContent}
          maxLength={notificationType === "Alert" ? 80 : 250}
          onChange={(e) => {
            setFormData((prev) => ({
              ...prev,
              messageContent: e.target.value,
            }));
          }}
          showCount
          disabled={isReadOnly}
        />
      </>

      {notificationTypeSettings === "General" && (
        <div className="mt-2">
          <label className="input-label">Destination</label>
          <div className="flex align-center gap-4 mt-2 mb-2">
            <RadioComp
              data={notificationTypeData}
              selected={destinationType}
              onChange={handleDestinationChange}
              disabled={isReadOnly}
            />
          </div>

          {destinationType !== "None" && (
            <div className={style["destination-container"]}>
              {destinationType === "In-app" && (
                <div className={style.destination}>
                  <div className={style.halfWidth}>
                    <SelectComp
                      label="In-app screen"
                      placeholder="Select screen"
                      value={destinationScreen}
                      disabled={isReadOnly}
                      data={[
                        {
                          label: "Submission Listing",
                          value: "Submission Listing",
                        },
                        { label: "Bill Listing", value: "Bill Listing" },
                        {
                          label: "Know Your Councillor",
                          value: "Know Your Councillor",
                        },
                        { label: "News Listing", value: "News Listing" },
                      ]}
                      onChange={(value) => {
                        dispatch(setDestinationScreen(value));
                        setFormData((prev) => ({
                          ...prev,
                          destinationScreen: value,
                        }));
                      }}
                    />
                  </div>
                  <div className={style.halfWidth}>
                    <InputComp
                      maxLength={15}
                      showCount
                      label="Display as"
                      placeholder="e.g.: Check it out"
                      value={displayText}
                      onChange={(e) => {
                        dispatch(setDisplayText(e.target.value));
                        setFormData((prev) => ({
                          ...prev,
                          displayText: e.target.value,
                        }));
                      }}
                      disabled={isReadOnly}
                    />
                  </div>
                </div>
              )}

              {destinationType === "External" && (
                <div className={style.destination}>
                  <div className={style.halfWidth}>
                    <InputComp
                      label="External URL"
                      placeholder="Enter URL"
                      value={externalLink}
                      onChange={(e) => {
                        dispatch(setExternalLink(e.target.value));
                        setFormData((prev) => ({
                          ...prev,
                          externalLink: e.target.value,
                        }));
                      }}
                      disabled={isReadOnly}
                    />
                  </div>
                  <div className={style.halfWidth}>
                    <InputComp
                      showCount
                      maxLength={15}
                      label="Display as"
                      placeholder="e.g.: Check it out"
                      value={displayText}
                      onChange={(e) => {
                        dispatch(setDisplayText(e.target.value));
                        setFormData((prev) => ({
                          ...prev,
                          displayText: e.target.value,
                        }));
                      }}
                      disabled={isReadOnly}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {notificationTypeSettings === "General" && (
        <FileUploadComponent data={data} disabled={isReadOnly} />
      )}
    </div>
  );
};

export default MessageContent;
